import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';
import BaseApi from '~/api/base';
import { keysToCamel } from '~/utils/toCamelCase';
import mockComparisonDocuments from './mock';
class DocumentComparisons extends BaseApi {
    constructor() {
        super('/document-comparison-view');
    }
    getFileIds(payload) {
        if (this.useMock) {
            return mockComparisonDocuments.map(x => x.file_id);
        }
        return super.get(payload);
    }
    getFileByFileId(payload) {
        if (this.useMock) {
            return keysToCamel(mockComparisonDocuments.find(x => x.file_id === payload.fileId));
        }
        const fileId = payload.fileId;
        delete payload.fileId;
        return super.route(`/document-comparison-view/${fileId}`).get(payload);
    }
    post(payload) {
        if (this.useMock) {
            return keysToCamel({ document_comparison_id: uuidv4() });
        }
        return super.post(payload);
    }
    addComment(payload) {
        if (this.useMock) {
            const { classificationId, text } = payload;
            return {
                classificationId,
                comments: [{
                        id: uuidv4(),
                        author: 'Fake Personson',
                        text,
                        datetime: DateTime.now().toISO(),
                    }],
            };
        }
        return super.route('/document-comparison-view-comments').post(payload);
    }
    deleteComment(payload) {
        if (this.useMock) {
            return { commentId: payload.commentId, classificationId: payload.classificationId };
        }
        return super.route('/document-comparison-view-comments').delete(payload);
    }
    updateComment(payload) {
        const { commentId } = payload;
        if (this.useMock) {
            return;
        }
        return super.route('/document-comparison-view-comments').update(commentId, payload);
    }
}
const DocumentComparisonApi = new DocumentComparisons();
export default DocumentComparisonApi;
